import React from 'react'

interface InsightsProps {
  dateRange: [string | undefined, string | undefined]
  setDateRange: (date: [string | undefined, string | undefined]) => void
  trainingIds: number[]
  setTrainingIds: (trainingIds: number[]) => void
  trainingClassesIds: number[]
  setTrainingClassesIds: (trainingIds: number[]) => void
  teamIds: number[]
  setTeamIds: (teamIds: number[]) => void
}

const store = React.createContext<InsightsProps | null>(null)
export const Provider = store.Provider

export const useFilters = (): InsightsProps => {
  const context = React.useContext(store)

  if (!context) {
    throw new Error('useFilters must be used within an Insights Provider')
  }

  return context
}
